import {memo} from "react";

interface TransactionDetailProps {
    name: string,
    children: JSX.Element | string | number
}
const TransactionDetail = ({name, children}:TransactionDetailProps) => {
    return <div>
        <span className="inline-block mr-2">{name}:</span>
        <span className="font-bold">{children}</span>
    </div>
}

export default memo(TransactionDetail);
